module.exports = __webpack_public_path__ + "static/img/1-1Z604142533435.48be634.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z604142533435.jpg
// module id = TFvt
// module chunks = 0